import styled, { css } from 'styled-components'
import { Step } from '../components/Steps'

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-height: 5rem;
`

export const StepContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
`

export const CompactStep = styled(Step)`
  ${({ active, disabled, theme }) => css`
    padding: 0.6rem 1.2rem;
    font-size: 12px;
    letter-spacing: 1px;
    flex: 1 1 50%;
    min-width: 0;
    position: relative;
    border-bottom: none;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: ${active ? '2px' : '1px'};
      background-color: ${active
        ? theme.colors.primary
        : theme.colors.boxHeaderBorder};
    }

    ${disabled &&
    css`
      cursor: default;
      pointer-events: none;
      color: ${theme.colors.stepDisabled};

      &:hover {
        color: ${theme.colors.stepDisabled};
      }
    `}
  `}
`
